import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';

// Lists every validation failure above the form and links each one to its
// field, so the errors persist and can be reached by keyboard and screen reader.
const FormErrorSummary = ({ errors, title }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!errors.length) {
      return undefined;
    }
    // after the confirmation dialog has faded out and returned focus to its trigger
    const timer = setTimeout(() => ref.current && ref.current.focus(), 500);
    return () => clearTimeout(timer);
  }, [errors]);

  if (!errors.length) {
    return null;
  }

  const focusField = (e, id) => {
    const field = document.getElementById(id);
    if (field) {
      e.preventDefault();
      field.scrollIntoView({ block: 'center' });
      field.focus();
    }
  };

  return (
    <Alert color="danger" role="alert" tabIndex="-1" innerRef={ref} className="mb-3" id="form-error-summary">
      <h2 className="h5 alert-heading">{title}</h2>
      <ul className="mb-0 pl-3">
        {errors.map(({ id, message }) => (
          <li key={id}>
            <a href={'#' + id} className="alert-link" onClick={e => focusField(e, id)}>
              {message}
            </a>
          </li>
        ))}
      </ul>
    </Alert>
  );
};

FormErrorSummary.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired, message: PropTypes.string.isRequired }))
    .isRequired,
  title: PropTypes.string
};

FormErrorSummary.defaultProps = { title: 'Please fix the following before submitting' };

export default FormErrorSummary;
